module.exports = __webpack_public_path__ + "media/svgs/PDF-Icon-black-06ddb028d1b57cf452cc5048f9161170.svg";